export default __webpack_public_path__ + "static/media/bg-14.63899623.jpg";